import { TLinkField, TStringField } from '../../../types/sitecore.types';
import { THeadingTag } from '../../../types/types';
import { getFollowingHTag } from '../../../utils/seo.utils';
import { TExploreServicesCardProps } from '../components/exploreServicesCard/types/card.types';
import { TExploreServicesFields, TExploreServicesProps, TExploreServicesParams } from '../types/exploreOurServices.types';

export class ExploreServicesModel {
  private readonly fields: null | TExploreServicesFields;
  private readonly params?: TExploreServicesParams;

  constructor(props: TExploreServicesProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || undefined;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get link(): TLinkField | undefined {
    return this.fields?.link;
  }

  get cards(): TExploreServicesCardProps[] {
    return this.fields?.items && Array.isArray(this.fields?.items) ? this.fields?.items : [];
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
